import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Search, Loader2, X } from "lucide-react";
import api, { formatMoney, formatNumber } from "../lib/api";
import { FichaProducto } from "./FichaProducto";

export function BuscadorGlobal() {
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [sel, setSel] = useState(0);
  const [cn, setCn] = useState(null);
  const ref = useRef(null);

  useEffect(() => {
    const t = q.trim();
    if (t.length < 2) { setItems([]); return undefined; }
    setLoading(true);
    const h = setTimeout(() => {
      api.get("/productos/buscar", { params: { q: t } }).then((r) => { setItems(r.data.items); setSel(0); })
        .catch(() => setItems([])).finally(() => setLoading(false));
    }, 250);
    return () => clearTimeout(h);
  }, [q]);
  useEffect(() => {
    const k = (e) => {
      if (e.key === "/" && !["INPUT", "TEXTAREA", "SELECT"].includes(document.activeElement?.tagName)) { e.preventDefault(); ref.current?.focus(); }
    };
    window.addEventListener("keydown", k);
    return () => window.removeEventListener("keydown", k);
  }, []);

  const abrir = (p) => { setCn(p.cn); setOpen(false); setQ(""); ref.current?.blur(); };
  const onKey = (e) => {
    if (e.key === "ArrowDown") { e.preventDefault(); setSel((s) => Math.min(s + 1, items.length - 1)); }
    if (e.key === "ArrowUp") { e.preventDefault(); setSel((s) => Math.max(s - 1, 0)); }
    if (e.key === "Enter" && items[sel]) abrir(items[sel]);
    if (e.key === "Escape") { setOpen(false); ref.current?.blur(); }
  };

  return (
    <>
      <div className="relative w-full max-w-xl" data-testid="buscador-global">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
        <input ref={ref} value={q} onChange={(e) => { setQ(e.target.value); setOpen(true); }} onFocus={() => setOpen(true)} onKeyDown={onKey}
               onBlur={() => setTimeout(() => setOpen(false), 150)} placeholder="Buscar producto por nombre o CN…  ( / )"
               className="input w-full bg-slate-50 focus:bg-white" style={{ paddingLeft: 34, paddingRight: 32 }} data-testid="buscador-global-input" />
        {loading ? <Loader2 size={14} className="absolute right-3 top-1/2 -translate-y-1/2 animate-spin text-slate-400" />
          : q && <button onMouseDown={() => setQ("")} className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-slate-400 hover:text-slate-700" data-testid="buscador-global-clear"><X size={14} /></button>}
        {open && q.trim().length >= 2 && !loading && (
          <div className="absolute z-[65] mt-1 w-full max-h-[70vh] overflow-auto rounded-lg border border-slate-200 bg-white shadow-xl" data-testid="buscador-global-resultados">
            {items.length === 0 ? <div className="px-3 py-3 text-sm text-slate-500" data-testid="buscador-global-vacio">Ningún producto coincide con «{q.trim()}».</div>
              : items.map((p, i) => (
                <button key={p.cn} onMouseDown={() => abrir(p)} onMouseEnter={() => setSel(i)} data-testid={`buscador-global-item-${p.cn}`}
                        className={"w-full text-left px-3 py-2 flex items-center gap-3 border-b border-slate-100 last:border-0 " + (i === sel ? "bg-slate-50" : "")}>
                  <span className="font-mono text-xs text-slate-500 w-14 shrink-0">{p.cn}</span>
                  <span className="flex-1 min-w-0">
                    <span className="block text-sm font-semibold truncate">{p.descripcion}</span>
                    <span className="block text-[11px] text-slate-500 truncate">{p.laboratorio}</span>
                  </span>
                  {p.abcd && <span className={`abcd-pill abcd-${p.abcd} whitespace-nowrap`}>{p.abcd}</span>}
                  <span className="text-right shrink-0 w-24">
                    <span className="block text-xs font-semibold">{formatMoney(p.tot_venta)}</span>
                    <span className="block text-[11px] text-slate-500">stock {formatNumber(p.stock)}</span>
                  </span>
                </button>
              ))}
          </div>
        )}
      </div>
      {createPortal(<FichaProducto cn={cn} onClose={() => setCn(null)} />, document.body)}
    </>
  );
}
